export default __webpack_public_path__ + "static/media/PosterMB-1.abcf27f6.JPG";